import { localisable } from "../../generic/localisable"
import { mapEnum } from "../../utils/mapEnum"

const TENANT_FIELD = ['first_name', 'last_name', 'phone', 'email', 'address_line1', 'address_line2', 'city', 'state', 'zip_code', 'driver_license_number', 'driver_license_expiration', 'birth_date', 'military_type',
    'military_branch', 'military_id', 'military_deployed_date', 'military_division', 'military_commanding_officer', 'military_commanding_officer_number', 'unit_type', 'rate', 'total_charges', 'period', 'alternate_first_name', 'alternate_last_name', 'alternate_phone', 'alternate_email', 'alternate_address_line1', 'alternate_address_line2', 'alternate_city', 'alternate_state', 'alternate_zip_code',]
const UNIT_FIELD = ['unit_type', 'rate', 'total_charges', 'period', 'move_in_date', 'reservation_charges']
const TENANT_FIELD_OBJECT = mapEnum(TENANT_FIELD)
const UNIT_FIELD_OBJECT = mapEnum(UNIT_FIELD)

const TENANT_FIELD_MAPPING = {
    [TENANT_FIELD_OBJECT.FIRST_NAME]: localisable.firstName,
    [TENANT_FIELD_OBJECT.LAST_NAME]: localisable.lastName,
    [TENANT_FIELD_OBJECT.PHONE]: localisable.phone,
    [TENANT_FIELD_OBJECT.EMAIL]: localisable.email,
    [TENANT_FIELD_OBJECT.ADDRESS_LINE1]: localisable.addressLine1,
    [TENANT_FIELD_OBJECT.ADDRESS_LINE2]: localisable.addressLine2,
    [TENANT_FIELD_OBJECT.CITY]: localisable.city,
    [TENANT_FIELD_OBJECT.STATE]: localisable.stateProvince,
    [TENANT_FIELD_OBJECT.ZIP_CODE]: localisable.zipCode,
    [TENANT_FIELD_OBJECT.DRIVER_LICENSE_NUMBER]: localisable.licenseNumber,
    [TENANT_FIELD_OBJECT.DRIVER_LICENSE_EXPIRATION]: localisable.licenseExpiration,
    [TENANT_FIELD_OBJECT.BIRTH_DATE]: localisable.birthDate,
    [TENANT_FIELD_OBJECT.MILITARY_TYPE]: localisable.militaryType,
    [TENANT_FIELD_OBJECT.MILITARY_BRANCH]: localisable.militaryBranch,
    [TENANT_FIELD_OBJECT.MILITARY_ID]: localisable.militaryID,
    [TENANT_FIELD_OBJECT.MILITARY_DEPLOYED_DATE]: localisable.militaryDeployedDate,
    [TENANT_FIELD_OBJECT.MILITARY_DIVISION]: localisable.militaryDivision,
    [TENANT_FIELD_OBJECT.MILITARY_COMMANDING_OFFICER]: localisable.commandingOfficer,
    [TENANT_FIELD_OBJECT.MILITARY_COMMANDING_OFFICER_NUMBER]: localisable.commandingOfficerNumber,
    [TENANT_FIELD_OBJECT.ALTERNATE_FIRST_NAME]: localisable.firstName,
    [TENANT_FIELD_OBJECT.ALTERNATE_LAST_NAME]: localisable.lastName,
    [TENANT_FIELD_OBJECT.ALTERNATE_PHONE]: localisable.phone,
    [TENANT_FIELD_OBJECT.ALTERNATE_EMAIL]: localisable.email,
    [TENANT_FIELD_OBJECT.ALTERNATE_ADDRESS_LINE1]: localisable.addressLine1,
    [TENANT_FIELD_OBJECT.ALTERNATE_ADDRESS_LINE2]: localisable.addressLine2,
    [TENANT_FIELD_OBJECT.ALTERNATE_CITY]: localisable.city,
    [TENANT_FIELD_OBJECT.ALTERNATE_STATE]: localisable.stateProvince,
    [TENANT_FIELD_OBJECT.ALTERNATE_ZIP_CODE]: localisable.zipCode,
}
const UNIT_FIELD_MAPPING = {
    [UNIT_FIELD_OBJECT.UNIT_TYPE]: localisable.unitType,
    [UNIT_FIELD_OBJECT.RATE]: localisable.rate,
    [UNIT_FIELD_OBJECT.TOTAL_CHARGES]: localisable.totalCharges,
    [UNIT_FIELD_OBJECT.PERIOD]: localisable.period,
    [UNIT_FIELD_OBJECT.MOVE_IN_DATE]: localisable.moveInDate,
    [UNIT_FIELD_OBJECT.RESERVATION_CHARGES]: localisable.reservationCharges,
}
export { TENANT_FIELD_MAPPING, TENANT_FIELD, UNIT_FIELD_MAPPING, UNIT_FIELD }

export const tableItemProps = {
    padding: '16px',
    gap: '16px',
    width: '100%'
}
export const tableFlexStyles = {
    gap: '24px',
    direction: "column" as 'column',
    width: '100%'
}
export const containerStyles = {
    direction: "column" as 'column',
    bg: "background.main",
    color: "text.grey",
    padding: { base: '16px 8px', sm: '16px' },
    width: '100%',
    gap: '24px'
}
export const tableStyles = {

    gap: { base: '24px', sm: '56px' },
    justifyContent: 'center',
    width: '100%',
}

export const ctaButtonProps = {
    direction: { base: 'column' as 'column', sm: 'row' as 'row' },
    gap: "16px",
    alignItems: "center",
    justifyContent: { base: 'center', sm: 'flex-end' }
}
